import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowUpIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m17.71 11.29-5-5a.9994.9994 0 0 0-.33-.21 1 1 0 0 0-.76 0 1.0004 1.0004 0 0 0-.33.21l-5 5a1.0041 1.0041 0 0 0 1.42 1.42L11 9.41V17a1.0001 1.0001 0 0 0 2 0V9.41l3.29 3.3a.9997.9997 0 0 0 1.42 0 .9998.9998 0 0 0 0-1.42Z"/>
  </SvgIcon>
}

export default LineArrowUpIcon
